/* Newesfera Lumière — interacciones */
(function () {
  'use strict';

  /* ---- Barra de anuncios: rota los mensajes ---- */
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announce__item');
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 4500);
  });

  /* ---- Menú móvil ---- */
  var drawer = document.querySelector('[data-drawer]');
  var opener = document.querySelector('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var c = drawer.querySelector('.drawer__close'); if (c) c.focus(); }
    else if (opener) { opener.focus(); }
  }
  if (opener) opener.addEventListener('click', function () { setDrawer(true); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  if (drawer) drawer.querySelectorAll('.drawer__nav a').forEach(function (a) {
    a.addEventListener('click', function () { setDrawer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* ---- Botones de cantidad (ficha y cesta) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* En la cesta, al cambiar cantidad se actualiza automáticamente */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var form = input.form;
        var upd = form && form.querySelector('[data-cart-update]');
        if (upd) upd.click();
      }, 600);
    });
  });

  /* ---- Galería ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.gallery__main img');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = t.getAttribute('data-src');
        main.setAttribute('srcset', t.getAttribute('data-srcset'));
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---- Variantes (solo si el producto tiene más de una) ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var idInput = form.querySelector('[data-variant-input]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var selected = [];
      form.querySelectorAll('.variant-picker').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        selected.push(c ? c.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!match) {
        addBtn.disabled = true; addLabel.textContent = 'No disponible';
        return;
      }
          idInput.value = match.id;
      if (match.featured_media && match.featured_media.preview_image) {
        var section = form.closest('[data-product-section]');
        var mainImg = section && section.querySelector('.gallery__main img');
        if (mainImg) {
          var src = match.featured_media.preview_image.src;
          mainImg.removeAttribute('srcset');
          mainImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
          section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        }
      }
      addBtn.disabled = !match.available;
      addLabel.textContent = match.available ? 'Añadir a la cesta' : 'Agotado';
      var url = new URL(window.location.href);
      if (url.pathname.indexOf('/products/') !== -1) {
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---- Barra de compra fija: aparece al pasar el botón de compra ---- */
  var sticky = document.querySelector('[data-sticky-buy]');
  var buyBtn = document.querySelector('[data-add-button]');
  if (sticky && buyBtn) {
    var footer = document.querySelector('.footer');
    var cta = sticky.querySelector('[data-sticky-cta]');
    var ticking = false;
    var update = function () {
      ticking = false;
      var past = buyBtn.getBoundingClientRect().bottom < 0;
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = past && !nearFooter;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (cta) cta.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---- Modos de luz ---- */
  document.querySelectorAll('[data-lights]').forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      sec.style.setProperty('--glow', tab.getAttribute('data-color'));
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  });
})();
